const preferredColumns = [
  "found",
  "original_rank",
  "sem_sim_fuzzy",
  "sem_sim_closest",
  "usr_primary_labels",
  "usr_secondary_labels",
  "usr_primary_tags",
  "usr_secondary_tags",
  "user_affinity_avg",
  "user_affinity_usdc",
  "user_affinity_count",
  "cluster_1",
  "cluster_2",
  "cluster_3",
  "cluster_4",
  "cluster_5",
  "cluster_6",
  "cluster_7",
  "cluster_8",
  "cluster_9",
  "cluster_10",
  "sem_sim_cluster1",
  "sem_sim_cluster2",
  "sem_sim_cluster3",
  "sem_sim_cluster4",
  "sem_sim_cluster5",
] ;

const sortAvailableFeatures = (available) => {
  const preferred = preferredColumns.filter(col => available.includes(col));
  const nonPreferred = available.filter(col => !preferredColumns.includes(col));
  const regular = nonPreferred.filter(col => !col.startsWith('AI:') && !col.startsWith('TAG:')).sort();
  const aiColumns = nonPreferred.filter(col => col.startsWith('AI:')).sort();
  const tagColumns = nonPreferred.filter(col => col.startsWith('TAG:')).sort();
  const list = [...preferred, ...regular, ...aiColumns, ...tagColumns]
  return list;
}

const getPreferredColumns = (available) => {
  if (available) {
    return available.filter(col => preferredColumns.includes(col));
  } else {
    return [];
  }
}

const getAvailableData = (hits) => {
  const ans = { features: [], scores: [], ranking: false };
  if (!hits || hits.length === 0) {
      return ans
  }
  const availableFeatures = {};
  const availableScores = {};
  for (const hit of hits) {
    if (hit._features) {
      for (const [key, value] of Object.entries(hit._features)) {
        if (typeof value === 'number' && !Number.isNaN(value)) {
          availableFeatures[key] = true;
        }
      }
    }
    if (hit._scores) {
      for (const [key, value] of Object.entries(hit._scores)) {
        if (typeof value === 'number' && !Number.isNaN(value)) {
          availableScores[key] = true;
        }
      }
    }
    if (hit._ranking_score) {
      ans.ranking = true;
    }
  }
  ans.features = sortAvailableFeatures(Object.keys(availableFeatures));
  ans.scores = Object.keys(availableScores);
  return ans;
};

export { preferredColumns, sortAvailableFeatures, getPreferredColumns, getAvailableData };